export const configurationPermissions = {

    computed: {

        canVettedNotes() {

            return this.$store.getters["Auth/hasPermission"]("can manage vetted notes");

        },

        canManageCodes() {

            return this.$store.getters["Auth/hasPermission"]("can manage codes");

        },

        canManageServiceLevels() {

            return this.$store.getters["Auth/hasPermission"]("can manage service levels");

        },

        canManageRoles() {

            return this.$store.getters["Auth/hasPermission"]("can manage roles");

        },

        canManageTags() {

            return this.$store.getters["Auth/hasPermission"]("can manage tags");

        },

        canViewNotifications() {

            return this.$store.getters["Auth/hasPermission"]("can view notifications");

        },

        canViewTests() {

            return this.$store.getters["Auth/hasPermission"]("can view tests");

        },

        canManageUsers() {

            return this.$store.getters["Auth/hasPermission"]("can view users") && this.$store.getters["Auth/hasPermission"]("can manage users");

        },

        isSuperadmin() {

            return this.$store.getters["Auth/hasRole"]("superadmin")

        },

        canManageTemplates() {

            return this.$store.getters["Auth/hasRole"]("superadmin") || this.$store.getters["Auth/hasPermission"]("can manage templates")

        },

        configuration() {

            let configTabs = [];

            if (this.isSuperadmin) {
                configTabs.push({
                    name: "USERS",
                    route: "configuration.users"
                });
              }

            // Moved to organizations' tabs
            // if (this.canVettedNotes) {
            //     configTabs.push({
            //         name: "VETTED NOTES",
            //         route: "configuration.vetted-notes"
            //     });
            // }

            if (this.canManageCodes) {
                configTabs.push({
                    name: "CODES",
                    route: "configuration.codes"
                });
            }

            if (this.canManageServiceLevels) {
                configTabs.push({
                    name: "SERVICE LEVELS",
                    route: "configuration.service-levels"
                });
            }

            if (this.canManageRoles) {
                configTabs.push({
                    name: "ROLES",
                    route: "configuration.roles"
                });
            }

            if (this.canManageTags) {
                configTabs.push({
                    name: "TAGS",
                    route: "configuration.tags"
                });
            }

            if (this.canViewNotifications) {
                configTabs.push({
                    name: "NOTIFICATIONS",
                    route: "configuration.notifications"
                });
            }

            if (this.isSuperadmin) {
                configTabs.push({
                    name: "LOGS",
                    route: "configuration.logs"
                });
            }

            if (this.canViewTests) {
                configTabs.push({
                    name: "AUTOMATED TESTING",
                    route: "configuration.automated-testing"
                });
            }

            if (this.isSuperadmin) {
                configTabs.push({
                    name: "PORTALS",
                    route: "configuration.portals"
                });
            }

            if (this.canManageTemplates) {
                configTabs.push({
                    name: 'ORDER PDF',
                    route: 'configuration.order-pdf-template'
                });
            }

            if (this.canManageTemplates) {
                configTabs.push({
                    name: 'TEMPLATES',
                    route: 'configuration.templates'
                });
            }

            return configTabs;

        },

        configurationStatus() {

            return this.configuration.length ? true : false;

        }

    }

};



// WEBPACK FOOTER //
// ./src/mixins/configurationPermissions.js